export default __webpack_public_path__ + "screens_sm@2x.076935ea.png";